import {Queue} from "buckets-js";
import RpcClass from "@/server/RpcClass";
import Events from "@/utils/Events";
import EventBus from "@/utils/EventBus";
import RpcClientInternalException from "@/server/com/silkplm/engine/rpc/exceptions/RpcClientInternalException";
import RpcServerInternalException from "@/server/com/silkplm/engine/rpc/exceptions/RpcServerInternalException";
import Client from "@/utils/Client";
import * as fflate from 'fflate';
const programStartTime = performance.now();

class WsCallEntry {
    constructor() {
        this.promise = null;
        this.resolve = null;
        this.reject = null;

        this.timer = null;
        this.parametersArray = null;
        this.rpcMethod = null;
        this.startTime = null;
        this.sequence = null;
        this.msg = null;

        this.events = {};
    }

    on(event, callback){
        if(!this.events.hasOwnProperty(event)){
            this.events[event] = [];
        }
        this.events[event].push(callback);
    }

    trigger(event){
        if(this.events.hasOwnProperty(event)){
            this.events[event].forEach(callback =>{
                try {
                    callback(this);
                } catch (e){
                    Log.warn(e, true);
                }
            });
        }
    }
}

class PipeStatus {
    constructor() {
        this.connected = false;
        this.pendingRpcForSend = [];
        this.broadcasts = new Queue();
    }
}

export class WsPipe {
    constructor(endpoint, onConstructedListener, onBrokenListener) {
        this.logsSize = 100;
        this.activeLogin = activeLogin;

        //events

        this.onConstructed = onConstructedListener;
        this.onBrokenListener = onBrokenListener;
        
        this.pipeStatus = new PipeStatus();

        //fields
        this.endpoint = endpoint;
        this.messagesStack = {};
        this.sequence = 0;

        this.constructed = false;

        this.websocket = null;
        this.pendingRpcs = 0;
        
        this.reonnectTimeout = null;

        this.keepAliveInProgress = false;
        this.lastFallbackStatus = false;
        this.lastKnownStatus = "disconnected";
        this.lastSuccessTime = Date.now();

    }

    connect() {
        if(this.websocket &&  (this.websocket.readyState === WebSocket.OPEN || this.websocket.readyState === WebSocket.CONNECTING)){
            return;
        }
        this.websocket = new WebSocket(this.endpoint);

        let t = this;
        this.websocket.onopen = function (evt) {
            t.onOpen(evt)
        };
        this.websocket.onmessage = function (evt) {
            t.onMessage(evt)
        };
        this.websocket.onerror = function (evt) {
            t.onError(evt)
        };

        this.websocket.onclose = function (evt) {
            t.onClose(evt);
        }
    }

    reconnect(){
        if(!activeLogin || !this.activeLogin || this.activeLogin != activeLogin){
            return;
        }

        let delay = 10000;

        if(this.websocket && this.websocket.readyState != WebSocket.CLOSED){
            try{
                this.websocket.close();
                this.websocket = null;
                this.pipeStatus.connected = false;
            } catch (e){
                console.log(e);
            }
        }

        if(this.reonnectTimeout){
            return;
        }
        this.reonnectTimeout = setTimeout(() =>{
            this.reonnectTimeout = null;
            if(!activeLogin || this.activeLogin != activeLogin){
                return;
            }
            this.connect();
        }, delay);
    }

    close() {
        this.activeLogin = null;
        try {
            if (this.websocket) {
                this.websocket.close();
            }
        } catch (e){
            console.log(e);
        }
        this.websocket = null;

        this.pipeStatus.connected = false;
    }

    doPost(relativeUri, parametersArray, csrfToken, targetUrl, back){
        let wsCallEntry = new WsCallEntry();
        Client.interceptReq(wsCallEntry);
        let res = new Promise((resolve, reject) => {
            wsCallEntry.resolve = resolve;
            wsCallEntry.reject = reject;
        })

        wsCallEntry.rpcMethod = relativeUri;
        wsCallEntry.parametersArray = parametersArray;
        wsCallEntry.sequence = this.sequence++;
        wsCallEntry.startTime = new Date().getTime();

        wsCallEntry.timer = setTimeout(()=>{
            if(this.messagesStack.hasOwnProperty('k' + wsCallEntry.sequence)) {

                delete this.messagesStack['k' + wsCallEntry.sequence];
                this.pendingRpcs--;

                if (this.pendingRpcs == 0) {
                    this.messagesStack = {};
                }
                try {
                    wsCallEntry.trigger("timeout");
                    wsCallEntry.trigger("end");
                    wsCallEntry.reject(new RpcServerInternalException("timeout"));
                } catch (err) {
                    this.errorLog(err);
                }
            }
        }, 300000);

        this.messagesStack['k' + wsCallEntry.sequence] = wsCallEntry;
        let tag = "";
        if(back['tag']){
            tag = "\nx-tag:" + back['tag']
        }

        let msg = "rpc-exec\nsequence:" + wsCallEntry.sequence +
            "\nx-token:" + csrfToken +
            tag +
            "\nuri:" + relativeUri +
            "\n\n";

        wsCallEntry.msg = msg + JSON.stringify(parametersArray);

        this.websocket.send(wsCallEntry.msg);

        this.pendingRpcs++;

        wsCallEntry.promise = res;
        back['req'] = res;
        res.on = function(ev, callback){
            if(undefined === res.handlers){
                res.handlers = {};
            }
            res.handlers[ev] = callback;
        }
        return res.finally(()=>{
            if(res.handlers && res.handlers.end){
                res.handlers.end();
            }
        });
    }

    onOpen(evt) {
        Log.info("WsPipe connected to the endpoint:" + this.endpoint);
        this.onConstructed && this.onConstructed()

        if(!localStorage.getItem("disable-compression")) {
            this.websocket.send("compression-on");
        }
        if(window["_windowUUID"]) {
            Log.info("window UUID set to: " + window["_windowUUID"]);
            this.websocket.send("window-uuid:" + window["_windowUUID"]);
        } else {
            Log.warn("window UUID is empty");
        }

        this.pipeStatus.connected = true;
        if(this.lastKnownStatus !== "connected") {
            EventBus.$emit(Events.pushChannelConnected);
            this.lastKnownStatus = "connected";
        }
        EventBus.recoverAfterWsFailure();
        this.keepAlive();
    }

    onMessage(evt) {
        if(!this.pipeStatus.connected){
            return;
        }

        this.lastSuccessTime = Date.now();
        if(evt.data instanceof Blob){
            evt.data.arrayBuffer().then(buff =>{
                let u8data =  new Uint8Array(buff);
                let decompressed = fflate.unzlibSync(u8data);
                let dataJSON = fflate.strFromU8(decompressed);

                try {
                    let obj = JSON.parse(dataJSON);
                    if (obj.hasOwnProperty("results") && obj.hasOwnProperty("clientId")) {
                        this.handleRpc(evt, obj);
                    } else {
                        RpcClass.dispatchPush(obj).then(function () {
                        });
                    }
                }catch (e){
                    Log.fatal("Parse error: " + dataJSON);
                }


            });
            return;
        }
        if(evt.data === "keep-alive-ack"){
            this.keepAliveInProgress = false;
            Log.trace("Keep alive ACK received");
            return;
        }

        let dataJSON = evt.data;
        try {
            let obj = JSON.parse(dataJSON);
            if (obj.hasOwnProperty("results") && obj.hasOwnProperty("clientId")) {
                this.handleRpc(evt, obj);
            } else {
                RpcClass.dispatchPush(obj).then(function () {
                });
            }
        }catch (e){
            Log.fatal("Parse error: " + dataJSON);
        }
    }

    handleRpc(evt, obj) {
        let sequence = obj.clientId;

        if (sequence != null) {
            let wsCallEntry = this.messagesStack['k' + sequence];
            if (!wsCallEntry) {
                Log.warn("No sequence found in stack in:" + evt.data);
                return;
            }
            delete this.messagesStack['k' + sequence];
            this.pendingRpcs--;

            if (this.pendingRpcs == 0) {
                this.messagesStack = {};
            }

            wsCallEntry.trigger("response");
            wsCallEntry.trigger("end");

            clearTimeout(wsCallEntry.timer);

            try {
                wsCallEntry.resolve({body:obj, header:{}});
                if(obj['wsSessionChanged']){
                    SessionManager.refreshSession().then();
                }
            } catch (err) {
                this.errorLog(err);
            }
        }
        else {
            this.errorLog("No sequence in:" + evt.data);
        }
    }

    onError(evt) {
        this.cleanUnfinished();

        if(this.lastKnownStatus !== "disconnected" && this.lastKnownStatus !== "fallback") {
            EventBus.$emit(Events.pushChannelFallback);
            this.lastKnownStatus = "fallback";
        }
        this.keepAliveInProgress = false;

        RpcClass.wsPipeBroken();
        if (!this.constructed) {
            Log.fatal("WsPipe not constructed - error during construction");
        }
        else {
            Log.fatal("WsPipe connection error",false);

            this.pipeStatus.connected = false;
            //this.onConnectionError && this.onConnectionError(evt.data);
        }

        if(activeLogin) {
            this.reconnect();
        }
        this.onBrokenListener && this.onBrokenListener(evt.data);

    }

    onClose(evt) {
        Log.info("WsPipe disconnected", false);
        this.keepAliveInProgress = false;
        this.cleanUnfinished();
        if(activeLogin){
            if(this.lastKnownStatus !== "disconnected" && this.lastKnownStatus !== "fallback") {
                EventBus.$emit(Events.pushChannelFallback);
                this.lastKnownStatus = "fallback";
            }

            this.reconnect();
        } else {
            if(this.lastKnownStatus !== "disconnected" && this.lastKnownStatus !== "fallback") {
                EventBus.$emit(Events.pushChannelDisconnected);
                this.lastKnownStatus = "disconnected";
            }

        }

        this.pipeStatus.connected = false;
        this.onBrokenListener && this.onBrokenListener(evt.data);
    }


    cleanUnfinished(){
        for(let k in this.messagesStack){
            let wsCallEntry = this.messagesStack[k];
            try {
                wsCallEntry.trigger("error");
                wsCallEntry.trigger("end");
                clearTimeout(wsCallEntry.timer);
                wsCallEntry.reject(new RpcClientInternalException("Socket closed"));
            } catch (err) {
                this.errorLog(err);
            }
        }

        this.pendingRpcs = 0;
        this.messagesStack = {};

    }

    errorLog(msg) {
        Log.fatal(msg);
    }

    keepAlive(){
        if(this.keepAliveInProgress){
            return;
        }

        if(Date.now() - this.lastSuccessTime < 10 * 1000){
            return;
        }

        this.keepAliveInProgress = true;
        if(this.websocket && this.websocket.readyState === WebSocket.OPEN){
            Log.trace("WsPipe: keep-alive");
            this.websocket.send("keep-alive");
        } else {
            RpcClass.fallbackKeepAlive((status) =>{
                Log.trace("WsPipe - fallback: keep-alive");
                this.lastFallbackStatus = status;
                this.fallbackPushReceived(status);
            } );
        }
    }

    fallbackPushReceived(status){
        if(!this.websocket || this.websocket.readyState === WebSocket.CLOSED) {
            if (status) {
                if(this.lastKnownStatus !== "fallback") {
                    EventBus.$emit(Events.pushChannelFallback);
                    this.lastKnownStatus = "fallback";
                }
            } else {
                if(this.lastKnownStatus !== "disconnected") {
                    EventBus.$emit(Events.pushChannelDisconnected);
                    this.lastKnownStatus = "disconnected";
                }
            }
        } else {
            if(this.lastKnownStatus !== "connected") {
                EventBus.$emit(Events.pushChannelConnected);
                this.lastKnownStatus = "connected";
            }

        }
        this.keepAliveInProgress = false
    }

}

let timer = null;
let _defaultWsPipe = null;
let activeLogin = null;

WsPipe.PUSH_SOCKET_PATH = "/push";
WsPipe.PUSH_SOCKET_ADDR = null;
WsPipe.SESSION_ID = null;
WsPipe.KEEP_ALIVE_INTERVAL = 20 * 1000;


export function connected(){
    if(!_defaultWsPipe || !_defaultWsPipe.websocket){
        return false;
    }

    return _defaultWsPipe.websocket.readyState === WebSocket.OPEN || _defaultWsPipe.websocket.readyState === WebSocket.CONNECTING;
}

export function startListen(){
    /** @type {WsPipe} */

    if(window['_disable_ws']){
        return;
    }

    let url;

    if(window && window["_wsEndpoint"]){
        url =  window["_wsEndpoint"];
    }

    else if(WsPipe.PUSH_SOCKET_ADDR){
        url = WsPipe.PUSH_SOCKET_ADDR;
    } else {
        if (window.location.protocol == "https:") {
            url = "wss://";
        } else {
            url = "ws://";
        }
        url += window.location.host;
    }
    let sess = "";
    if(WsPipe.SESSION_ID){
        sess = "&internal-x-sess=" + encodeURIComponent(WsPipe.SESSION_ID);
    }

    if(window.hasOwnProperty('_frontendBuildTag')){
        sess += "&x-build-tag=" +  encodeURIComponent(window['_frontendBuildTag']);
        sess += "&x-version=" +  encodeURIComponent(window['_frontendVersion']);
    }

    _defaultWsPipe = new WsPipe(url + WsPipe.PUSH_SOCKET_PATH + "?internal-x-token=" + RpcClass.csrfToken + sess, null, null);
    _defaultWsPipe.connect();
    RpcClass.wsPipe = _defaultWsPipe;
    setTimeout(function(){
        RpcClass.userListensForEvents = true;
    });
    timer = setInterval(() => _defaultWsPipe.keepAlive(), WsPipe.KEEP_ALIVE_INTERVAL);
}

export function stopListen(){
    RpcClass.stopWsPipeFallback();
    RpcClass.userListensForEvents = false;
    RpcClass.wsPipe = null;

    if(timer){
        clearInterval(timer);
        timer = null;
    }
    if(_defaultWsPipe){
        try{
            _defaultWsPipe.close();
        } catch (e){
            console.log(e);
        }
        _defaultWsPipe = null;
    }
}

/**
 *
 * @return {string} connected|fallback|disconnected
 */
export function getStatus() {
    if(!_defaultWsPipe){
        return "disconnected";
    }
   return _defaultWsPipe.lastKnownStatus;
}

export default function setupWsPipe() {
    EventBus.$on(Events.userSignedIn, (login) => {
        Log.trace("User signed in - starting WS")
        if (activeLogin == login && _defaultWsPipe) {
            return;
        }
        stopListen();
        activeLogin = login;
        try {
            startListen();
        }catch (e){
            console.log(e);
        }
    });

    EventBus.$on(Events.userSignedOut, () => {
        activeLogin = null;
        stopListen();
    });
}